import http from '@/publicResource/server/httpServer.js'

/* 获取短信验证码 */
export const getSMSCode = (data) => {
  return http({ url: '/userGateway/user/getSMSCode', method: 'post' }, data)
}

/* 获取邮箱验证码 */
export const getEmailCode = (data) => {
  return http({ url: '/userGateway/user/getEmailCode', method: 'post' }, data)
}

/* 普通用户注册 */
export const registerUser = (data) => {
  return http({ url: '/userGateway/user/registerUser', method: 'post' }, data)
}

/* 邮箱注册 */
export const registerUserByEmail = (data) => {
  return http({ url: '/userGateway/user/registerUserByEmail', method: 'post' }, data)
}

/* 手机号登录 */
export const phoneLogin = (data) => {
  return http({ url: '/userGateway/user/userLoginByMobile', method: 'post' }, data)
}

/* 帐号登录 */
export const nameLogin = (data) => {
  return http({ url: '/userGateway/user/userLoginByLoginName', method: 'post' }, data)
}

/* 刷新token */
export const refreshToken = (data) => {
  return http({ url: '/userGateway/user/refreshToken', method: 'post' }, data)
}

/* 实名认证 */
export const setRealNameAuthentication = (data) => {
  return http({ url: '/userGateway/user/setRealNameAuthentication', method: 'post' }, data)
}

/* 找回密码-手机号验证 */
export const resetUserPassWordValidate = (data) => {
  return http({ url: '/userGateway/user/resetUserPassWordValidate', method: 'post' }, data)
}

/* 找回密码-邮箱验证 */
export const resetUserPassWordEmailValidate = (data) => {
  return http({ url: '/userGateway/user/resetUserPassWordEmailValidate', method: 'post' }, data)
}

/* 重置密码 */
export const resetUserPassWord = (data) => {
  return http({ url: '/userGateway/user/resetUserPassWord', method: 'post' }, data)
}

/* 重置密码 */
export const resetUserPassWordByEmail = (data) => {
  return http({ url: '/userGateway/user/resetUserPassWordByEmail', method: 'post' }, data)
}

/* 首页统计数据 */
export const getPCHomeDataCount = (data) => {
  return http({ url: '/userGateway/home/getPCHomeDataCount', method: 'post' }, data)
}

export const getCountMediation = (data) => {
  return http({ url: '/userGateway/organization/caseTypeStatistics', method: 'post' }, data)
}

/* 数据字典 */
export const searchDictionaryInfo = (data) => {
  return http({ url: '/userGateway/dictionary/searchDictionaryInfo', method: 'post' }, data)
}
/*
获取二级案由
*/
export const searchDispute = (data) => {
  return http({ url: '/userGateway/dictionary/searchDispute', method: 'post' }, data)
}
/* 机构列表 - 机构管理中心 */
export const getOrganizationList = (data) => {
  return http({ url: '/userGateway/organization/getOrganizationList', method: 'post' }, data)
}

/* 机构详情 - 机构管理中心 */
export const searchBackstageOrganization = (data) => {
  return http({ url: '/userGateway/backstageOrganization/searchBackstageOrganization', method: 'post' }, data)
}

/* 服务人员列表 - 机构管理中心 */
export const getServicePersonListPage = (data) => {
  return http({ url: '/userGateway/servicePerson/getServicePersonListPage', method: 'post' }, data)
}

/* 服务人员详情 - 机构管理中心 */
export const searchServicePerson = (data) => {
  return http({ url: '/userGateway/servicePerson/searchServicePerson', method: 'post' }, data)
}

/* 案件分配列表|案件调解记录 - 机构管理中心 */
export const getMediationListPage = (data) => {
  return http({ url: '/userGateway/personalCenter/getMediationListPage', method: 'post' }, data)
}

/* 选择调解机构列表 - 机构管理中心 */
export const getMediateOrganizationList = (data) => {
  return http({ url: '/userGateway/organization/getMediateOrganizationList', method: 'post' }, data)
}

/* 转移调解机构 - 机构管理中心 */
export const changeOrg = (data) => {
  return http({ url: '/mastiff/case/changeOrg', method: 'post' }, data)
}

/* 案件详情 - 机构管理中心 */
export const getMediationInfo = (data) => {
  return http({ url: '/mastiff/mediation/getMediationInfo', method: 'post' }, data)
}

/* 转移调解机构 - 机构管理中心 */
export const getMediationProgress = (data) => {
  return http({ url: '/mastiff/mediation/getMediationProgress', method: 'post' }, data)
}
/* 聊天室获取历史消息 */
export const getMediationMsg = (data) => {
  return http({ url: '/basicGateway/room/queryHisMessage', method: 'post' }, data)
}
/* 聊天室上传文件 */
export const upLoadFile = (data) => {
  return http({ url: '/basicGateway/file/upload', method: 'post' }, data)
}
/* 聊天室下载文件 */
export const downLoadFile = (fileId) => {
  return http({ url: `basicGateway/file/download/${fileId}`, method: 'post' })
}

/* 平台职能 - 添加服务人员 - 机构管理中心 */
export const serchServicePersonGrantAuthInfo = (data) => {
  return http({ url: '/userGateway/servicePerson/serchServicePersonGrantAuthInfo', method: 'post' }, data)
}

/* 添加服务人员 - 机构管理中心 */
export const addServicePerson = (data) => {
  return http({ url: '/userGateway/servicePerson/addServicePerson', method: 'post' }, data)
}

/* 地区信息查询 - 机构管理中心 */
export const searchAreasInfo = (data) => {
  return http({ url: '/userGateway/area/searchAreasInfo', method: 'post' }, data)
}

/* 查询下级地址(跳过市辖区) - 机构管理中心 */
export const searchLowerLevelAreas = (data) => {
  return http({ url: '/userGateway/area/searchLowerLevelAreas', method: 'post' }, data)
}

/* 根据案件进度查询各进度的调解数量 - 机构管理中心 */
export const getMediationCountByCaseProgress = (data) => {
  return http({ url: '/userGateway/personalCenter/getMediationCountByCaseProgress', method: 'post' }, data)
}

/* 查询服务人员详情 - 添加服务人员的时候使用 - 机构管理中心 */
export const searchServicePersonByMobile = (data) => {
  return http({ url: '/userGateway/servicePerson/searchServicePersonByMobile', method: 'post' }, data)
}

/* 更新服务人员信息 - 机构管理中心 */
export const updateServicePersonRole = (data) => {
  return http({ url: '/userGateway/servicePerson/updateServicePersonRole', method: 'post' }, data)
}

/* 受理调解 - 机构管理中心 */
export const acceptCase = (data) => {
  return http({ url: '/mastiff/case/acceptCase', method: 'post' }, data)
}

/* 不受理调解 - 机构管理中心 */
export const rejectCase = (data) => {
  return http({ url: '/mastiff/case/rejectCase', method: 'post' }, data)
}

/* 分配调解员 - 机构管理中心 */
export const assignMediator = (data) => {
  return http({ url: '/mastiff/case/assignMediator', method: 'post' }, data)
}

/* 重新分配调解员 - 机构管理中心 */
export const assignMediatorAgain = (data) => {
  return http({ url: '/mastiff/case/assignMediatorAgain', method: 'post' }, data)
}

/* 调解员列表 - 机构管理中心 */
export const getMediatorListPage = (data) => {
  return http({ url: '/userGateway/servicePerson/getMediatorListPage', method: 'post' }, data)
}

/* 保存调解案件材料 - 纠纷登记员 */
export const dossierUpload = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/dossierUpload', method: 'post' }, data)
}

/* 删除案件材料 - 纠纷登记员 */
export const delFile = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/delFile', method: 'post' }, data)
}

/* 下载案件材料 - 纠纷登记员 */
export const dossierDownload = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/dossierDownload', method: 'post' }, data)
}

/* 用户统计报表 - 机构管理员 */
export const getUserReport = (data) => {
  return http({ url: '/userGateway/organization/getUserReport', method: 'post' }, data)
}

/* 案件统计报表 统计纠纷总量.调解总量,及总数量和纠纷数量统计和 - 机构管理员 */
export const caseTypeStatistics = (data) => {
  return http({ url: '/userGateway/organization/caseTypeStatistics', method: 'post' }, data)
}

/* 案件统计报表 各区域纠纷类型统计 - 机构管理员 */
export const businessTypeStatistics = (data) => {
  return http({ url: '/userGateway/organization/businessTypeStatistics', method: 'post' }, data)
}

/* 案件统计报表 获取业务类型统计 - 机构管理员 */
export const areaDisputeTypeStatistics = (data) => {
  return http({ url: '/userGateway/organization/areaDisputeTypeStatistics', method: 'post' }, data)
}

/* 案件统计报表 各区域调解案件数量统计 - 机构管理员 */
export const areaMediateCaseNumberStatistics = (data) => {
  return http({ url: '/userGateway/organization/areaMediateCaseNumberStatistics', method: 'post' }, data)
}

/* 卷宗列表 - 机构管理员 */
export const queryDossierList = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/queryDossierList', method: 'post' }, data)
}

/* 卷宗详情 - 机构管理员 */
export const displayFileDossier = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/displayFileDossier', method: 'post' }, data)
}

/* 卷宗进度 - 机构管理员 */
export const queryLawProgressList = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/queryLawProgressList', method: 'post' }, data)
}

/* 审核卷宗通过 - 机构管理员 */
export const auditLawDossier = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/auditLawDossier', method: 'post' }, data)
}

/* 卷宗退回 - 机构管理员 */
export const lawDossierBack = (data) => {
  return http({ url: '/mastiff/lawCaseDossier/lawDossierBack', method: 'post' }, data)
}

/* 修改调解员状态（在线/繁忙） - 个人信息 */
export const updateServicePersonStatus = (data) => {
  return http({ url: '/userGateway/user/updateServicePersonStatus', method: 'post' }, data)
}

/* 个人信息 - 个人中心 - 工作人员 */
export const searchLoginServicePerson = (data) => {
  return http({ url: '/userGateway/servicePerson/searchLoginServicePerson', method: 'post' }, data)
}

/* 编辑个人信息 - 个人中心 - 工作人员 */
export const updateServicePerson = (data) => {
  return http({ url: '/userGateway/servicePerson/updateServicePerson', method: 'post' }, data)
}

/* 修改手机号码 - 个人中心 - 工作人员 */
export const updateMobilePhone = (data) => {
  return http({ url: '/userGateway/user/updateMobilePhone', method: 'post' }, data)
}

/* 修改密码 - 个人中心 - 工作人员 */
export const updatePassword = (data) => {
  return http({ url: '/userGateway/user/updatePassword', method: 'post' }, data)
}

/* 编辑机构详情 - 个人中心 - 工作人员 */
export const updateBackstageOrganization = (data) => {
  return http({ url: '/userGateway/backstageOrganization/updateBackstageOrganization', method: 'post' }, data)
}

/* 信访代理人列表 - 机构管理员 */
export const listOrdinaryUserNew = (data) => {
  return http({ url: '/userGateway/ordinaryUser/listOrdinaryUserNew', method: 'post' }, data)
}

/* 新增信访代理人 - 机构管理员 */
export const insertOrdinaryUser = (data) => {
  return http({ url: '/userGateway/ordinaryUser/insertOrdinaryUser', method: 'post' }, data)
}

/* 信访代理人-代理案件记录 - 机构管理员 */
export const listPetitionAgentMediation = (data) => {
  return http({ url: '/userGateway/ordinaryUser/listPetitionAgentMediation', method: 'post' }, data)
}

/* 信访代理人详情 - 机构管理员 */
export const searchOrdinaryUserNew = (data) => {
  return http({ url: '/userGateway/ordinaryUser/searchOrdinaryUserNew', method: 'post' }, data)
}

/* 信访代理人评价 - 机构管理员 */
export const getUserEvaluatePageList = (data) => {
  return http({ url: '/userGateway/userEvaluate/getUserEvaluatePageList', method: 'post' }, data)
}
/* 登入页面获取公钥 - 首页 */
export const getPublicKey = (data) => {
  return http({ url: '/userGateway/user/getPublicKey', method: 'post' }, data)
}
/* 退出登入 - 首页 */
export const logoutOptions = (data) => {
  return http({ url: '/userGateway/user/loginOut', method: 'post' }, data)
}

// 获取政治面貌
export const getPolitical = (data) => {
  return http({ url: '/userGateway/dictionary/searchDictionaryInfo', method: 'post' }, data)
}

// 删除登记的案件
export const delCase = (data) => {
  return http({ url: '/mastiff/case/deleteCase', method: 'post' }, data)
}

// 获取广东统一登录验证码
export const getCodeImg = (data) => {
  return http({ url: "/userGateway/imageCode", method: "get" }, data);
  // return http({ url: "https://gytj.dg.cn/userGateway/imageCode", method: "get" }, data);
};



// WEBPACK FOOTER //
// ./src/publicResource/api/apiSetting.js